'use strict';

var _logger = require('common/logger');

var _logger2 = _interopRequireDefault(_logger);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

// catch any global unhandled promise rejections
window.onunhandledrejection = function (event) {
    var isTesting = process.env.NODE_ENV === 'test';
    var rethrowUnhandled = process.env.RETHROW_UNHANDLED_REJECTIONS;
    if (isTesting) {
        if (!rethrowUnhandled) {
            event.preventDefault();
        }
    } else {
        _logger2['default'].error('An unexpected error occurred. This has been reported to our engineering team. For further support, please contact apisupport@hellosign.com.', event.reason);
    }
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/utils/log-uncaught-promises.js
 ** module id = 481
 ** module chunks = 0
 **/